import { Component, OnInit } from '@angular/core';
import { StateService } from '../../services/state.service';
import { Router, NavigationEnd  } from '@angular/router';

@Component({
  selector: 'app-right-counter',
  templateUrl: './right-counter.component.html',
  styleUrls: ['./right-counter.component.css']
})
export class RightCounterComponent implements OnInit {

  vehicles:any = [];
  counterActive = 0;
  counterIdle = 0;
  counterStop = 0;
  currentRoute = '';
  
  constructor(private stateSvc: StateService, private router: Router) { }

  ngOnInit(): void {
	this.router.events.subscribe((event:any) => {
		if (event instanceof NavigationEnd) {
		  this.currentRoute = this.router.url;
		}
	});
	this.stateSvc.vehicles
	.subscribe((result) => {
		this.vehicles = result;
		this.counterActive = 0;
		this.counterIdle = 0;
		this.counterStop = 0;
		this.vehicles.forEach((vhcl) => {
			if(vhcl.status == 'active'){
				this.counterActive ++;
			}else if(vhcl.status == 'idle'){
				this.counterIdle ++;
			}else if(vhcl.status == 'stop'){
				this.counterStop ++;
			}
		});
	});
  }
  
  filterStatus(stt){
	  if(this.currentRoute == '/map' || this.currentRoute == '/trip' || this.currentRoute == '/fleet'){
		this.stateSvc.setRightStatusTrigger(stt);
	  }
  }

}
